import React from 'react';
import { TableViewComponent } from '../../../../ui-components/data-viz-ui/table/TableViewComponent';
import { MultiMetricComparisonTableViewUiComponentProps } from './types';

export const MultiMetricComparisonTableViewUiComponent = (
  props: MultiMetricComparisonTableViewUiComponentProps
) => {
  return <TableViewComponent {...props} />;
};
